export default {
    gitlab_url: "https://gitlab.aai.sh"
};
